module.exports = __webpack_public_path__ + "static/docs/2020-01-27_RegimoZH-Tuefwis_Baubeschrieb_Wohnen.c8ec2de1.pdf";